import { Activity, ArrowLeftRight, Atom, BarChart3, Bot, Briefcase, CalendarClock, CalendarHeart, CandlestickChart, ClipboardList, Coins, Crosshair, Egg, FileText, Gavel, Ghost, History, Layers, LayoutDashboard, LifeBuoy, MessageSquareWarning, Newspaper, Orbit, PiggyBank, Radio, Receipt, Scale, ScrollText, Settings, SlidersHorizontal, Sparkles, Target, TrendingDown, Trophy } from 'lucide-react';

export const NAV_SECTIONS = [
  {
    id: 'patrimoine',
    label: 'Patrimoine',
    items: [
      { to: '/dashboard', label: 'Tableau de bord', icon: LayoutDashboard, keywords: ['dashboard', 'accueil', 'synthese'] },
      { to: '/pea', label: 'Mon PEA', icon: PiggyBank, keywords: ['pea', 'plafond', 'versements', 'fiscalite', 'retrait', '5 ans', 'impots', 'simulateur'] },
      { to: '/portfolio', label: 'Portefeuille', icon: Briefcase, keywords: ['portfolio', 'positions', 'lignes', 'watchlist'] },
      { to: '/exposition', label: 'Exposition réelle', icon: Layers, keywords: ['exposition', 'etf', 'transparence', 'look-through', 'pays', 'devises', 'dollar', 'secteurs', 'entreprises'] },
      { to: '/rebalance', label: 'Rééquilibrage', icon: Scale, keywords: ['rebalance', 'allocation', 'cible', 'arbitrage', 'ordres'] },
      { to: '/performance', label: 'Performance', icon: Activity, keywords: ['rendement', 'volatilite', 'sharpe'] },
      { to: '/dividends', label: 'Dividendes', icon: Coins, keywords: ['dividends', 'coupons', 'versements'] },
      { to: '/history', label: 'Historique', icon: History, keywords: ['history', 'operations', 'cloturees', 'trades'] },
      { to: '/calme', label: 'Garder son calme', icon: LifeBuoy, keywords: ['panique', 'anti-panique', 'krach', 'baisse', 'vendre', 'peur', 'calme', 'chute'] },
    ],
  },
  {
    id: 'planification',
    label: 'Planification',
    items: [
      { to: '/objectif', label: 'Objectif', icon: Target, keywords: ['objectif', 'projection', 'monte carlo', 'retraite', 'simulation', 'probabilite', 'versement'] },
      { to: '/frais', label: 'Frais & fiscalité', icon: Receipt, keywords: ['frais', 'courtage', 'ter', 'etf', 'retenue a la source', 'fiscalite', 'cout'] },
    ],
  },
  {
    id: 'intelligence',
    label: 'Intelligence',
    items: [
      { to: '/analysis', label: 'Analyse IA', icon: Sparkles, keywords: ['analysis', 'ia', 'ai', 'analyse'] },
      { to: '/reports', label: 'Rapports quotidiens', icon: FileText, keywords: ['reports', 'rapport', 'matinal', 'experts', 'bilan', 'scorecard'] },
      { to: '/news', label: 'Actualités', icon: Newspaper, keywords: ['news', 'presse', 'articles'] },
      { to: '/rumors', label: 'Rumeurs', icon: MessageSquareWarning, keywords: ['rumors', 'signaux'] },
    ],
  },
  {
    id: 'laboratoire',
    label: 'Laboratoire',
    items: [
      { to: '/ghost', label: 'Portefeuille fantôme', icon: Ghost, keywords: ['ghost', 'fantome', 'panel', 'suivre', 'recommandations', 'comparaison'] },
      { to: '/constellation', label: 'Constellation', icon: Orbit, keywords: ['correlation', 'secteurs', 'concentration', 'diversification', 'graphe'] },
      { to: '/journal', label: 'Le Journal', icon: ScrollText, keywords: ['journal', 'une', 'quotidien', 'imprimer', 'pdf', 'papier'] },
      { to: '/wrapped', label: 'Mon année', icon: CalendarHeart, keywords: ['wrapped', 'bilan', 'annee', 'recap', 'image', 'partager'] },
      { to: '/proces', label: 'Le Procès', icon: Gavel, keywords: ['proces', 'tribunal', 'jury', 'verdict', 'procureur', 'defense'] },
      { to: '/multivers', label: 'Multivers', icon: Atom, keywords: ['multivers', 'univers', 'parallele', 'monte carlo', 'si j avais'] },
      { to: '/crise', label: 'Simulateur de crise', icon: TrendingDown, keywords: ['crise', 'krach', '2008', 'covid', 'simulateur', 'jeu', 'sang-froid', 'panique'] },
      { to: '/tamagotchi', label: 'Pépite', icon: Egg, keywords: ['tamagotchi', 'pepite', 'creature', 'sante', 'jeu'] },
    ],
  },
  {
    // Its own universe: electric blue accent while a /trading page is open.
    id: 'trading',
    label: 'Trading',
    tone: 'trade',
    items: [
      { to: '/trading', end: true, label: 'Salle des ordres', icon: CandlestickChart, keywords: ['trading', 'ordres', 'bourse', 'acheter', 'vendre', 'coupe-circuit', 'kill switch', 'sim'] },
      { to: '/trading/live', label: 'Salle de marché', icon: Radio, keywords: ['direct', 'live', 'cours', 'temps reel', 'ticker', 'marche', 'intraday'] },
      { to: '/trading/ordre', label: 'Passer un ordre', icon: ArrowLeftRight, keywords: ['ordre', 'acheter', 'vendre', 'limite', 'stop', 'oco', 'stop suiveur', 'ticket'] },
      { to: '/trading/pilote', label: 'Pilote du panel', icon: Bot, keywords: ['pilote', 'automatique', 'panel', 'experts', 'conviction', 'enveloppe', 'backtest', 'simulation'] },
      { to: '/trading/programmes', label: 'Achats étalés', icon: CalendarClock, keywords: ['dca', 'twap', 'etale', 'tranches', 'programme', 'lisser', 'achat progressif'] },
      { to: '/trading/sniper', label: 'Sniper', icon: Crosshair, keywords: ['sniper', 'radar', 'repli', 'seuil', 'cible', 'limite'] },
      { to: '/trading/arene', label: 'Arène des experts', icon: Trophy, keywords: ['arene', 'experts', 'classement', 'concours', 'votes', 'enveloppe'] },
      { to: '/trading/bilan', label: 'Bilan du trading', icon: BarChart3, keywords: ['bilan', 'execution', 'glissement', 'slippage', 'fantome', 'pilote', 'comparaison'] },
      { to: '/trading/journal', label: "Journal d'audit", icon: ClipboardList, keywords: ['journal', 'audit', 'historique', 'execution', 'slippage', 'ordres passes'] },
      { to: '/trading/reglages', label: 'Réglages trading', icon: SlidersHorizontal, keywords: ['identifiants', 'application saxo', 'cle', 'limites', 'risque', 'reel', 'sim', 'liste noire'] },
    ],
  },
  {
    id: 'compte',
    label: 'Compte',
    items: [
      { to: '/settings', label: 'Réglages', icon: Settings, keywords: ['settings', 'parametres', 'compte', 'cle api', 'mascotte'] },
    ],
  },
];

export const NAV_ITEMS = NAV_SECTIONS.flatMap((section) => section.items.map((item) => ({ ...item, section: section.label })));

// universeOf names the visual universe of a page: the Trading section has
// its own colours ([data-universe="trading"] on <html>).
export const universeOf = (pathname) => (pathname === '/trading' || pathname.startsWith('/trading/') ? 'trading' : 'patrimoine');

const REPORT_TABS = [
  [/^\/reports\/experts\/[^/]+$/, [{ label: "Rapports d'experts", to: '/reports/experts' }, { label: 'Panel' }], 'Panel d’experts'],
  [/^\/reports\/experts$/, [{ label: "Rapports d'experts" }], "Rapports d'experts"],
  [/^\/reports\/live$/, [{ label: 'Débat en direct' }], 'Débat en direct'],
  [/^\/reports\/scorecard$/, [{ label: 'Bilan du panel' }], 'Bilan du panel'],
  [/^\/reports\/earnings$/, [{ label: 'Résultats' }], 'Résultats des entreprises'],
  [/^\/reports\/[^/]+$/, [{ label: 'Rapport' }], 'Rapport quotidien'],
];

export const routeMeta = (pathname) => {
  const stock = pathname.match(/^\/stock\/(.+)$/);
  if (stock) {
    const symbol = decodeURIComponent(stock[1]);
    return { section: 'Patrimoine', title: symbol, crumbs: [{ label: 'Patrimoine' }, { label: 'Portefeuille', to: '/portfolio' }, { label: symbol }] };
  }
  // The most specific item wins (/trading/ordre over /trading).
  const item = NAV_ITEMS
    .filter((i) => pathname === i.to || pathname.startsWith(`${i.to}/`))
    .sort((a, b) => b.to.length - a.to.length)[0];
  if (!item) return { section: '', title: 'PEA Wallet', crumbs: [] };
  const base = [{ label: item.section }];
  if (item.to === '/reports') {
    const tab = REPORT_TABS.find(([re]) => re.test(pathname));
    if (tab) return { section: item.section, title: tab[2], crumbs: [...base, { label: item.label, to: '/reports' }, ...tab[1]] };
  }
  return { section: item.section, title: item.label, crumbs: [...base, { label: item.label }] };
};
